//
//
//
//
//
//
//
//

import BaseLoading from "@/components/BaseLoading";
require('@/assets/data_database_icon_177024.png');
import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import LineageBi from '@/modules/tasks/powerbi/components/LineageBI.vue';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
export default {
  name: 'DatasetTabLineage',
  components: {
    LineageBi: LineageBi,
    BaseLoading: BaseLoading
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {},
  data: function data() {
    return {
      reports: [],
      data_lineage: {},
      isLoading: false
    };
  },
  created: function created() {
    this.getReports();
  },
  mounted: function mounted() {},
  methods: {
    getReports: function getReports() {
      var _this = this;
      this.isLoading = true;
      BiDatasetService.getReports(this.item).then(function (response) {
        _this.data_lineage = {
          dataset: {
            "object_name": _this.item.object_name,
            "focus": true
          },
          reports: response.data,
          tables: _this.item.tables
        };
      }).finally(function () {
        _this.isLoading = false;
      });
    }
  }
};